<p>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-type-config.prompt' | translate }}</p>

<ul class="simple-list simple-indent" *ngIf="replaceWithEmailTypeConfig">
  <li>
    <label>
      <input type="checkbox" [(ngModel)]="replaceWithEmailTypeConfig.UsePrimary" />
      {{ 'communications.mass-comm-message-edit.mass-comm-profiles.email-type-config.primary-label' | translate }}
    </label>
  </li>

  <li *ngFor="let emailType of emailTypes">
    <label>
      <input
        type="checkbox"
        (click)="handleEmailTypeCheckboxClick($event, emailType.EmailAddressTypeID)"
        [checked]="replaceWithEmailTypeConfig.EmailAddressTypeIds.indexOf(emailType.EmailAddressTypeID) >= 0"
      />
      {{ emailType.Name }}
    </label>
  </li>
</ul>
